module Meevo.Plugins.Integrations {
    "use strict";
    import IIntegration = Meevo.Model.IIntegration;
    import IIntegrationErrorHeader = Meevo.Model.IIntegrationErrorHeader;
    import IntegrationStatusEnum = Meevo.Model.IntegrationStatusEnum;
    import IIntegrationErrorLogSearchCriteria = Meevo.Model.IIntegrationErrorLogSearchCriteria;

    interface ISetting {
        id: number,
        name: string
    }

    /**
     * Error Log Section of Integrations
     */
    export class LogSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.IIntegration> {
        showFailedEvents: boolean = false;
        showSuccessfulResubmissions: boolean = false;
        settingsList: Array<ISetting> = [];
        settingId: number = null;
        logList: Array<IIntegrationErrorHeader> = [];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings)
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public sectionModelRetrieved(): void {
            this.settingsList = [];

            this.model.integrationSettings.forEach((setting: Meevo.Model.IIntegrationSetting) => {
                this.settingsList.push({
                    id: setting.id,
                    name: setting.displayName
                });
            });

            this.filterLog();
        }

        /**
         * Filter log items
         * */
        public filterLog(): void {
            let statusEnum: IntegrationStatusEnum,
                criteria: IIntegrationErrorLogSearchCriteria;

            if ((this.showFailedEvents && this.showSuccessfulResubmissions) || (!this.showFailedEvents && !this.showSuccessfulResubmissions)) {
                statusEnum = null;
            } else if (this.showFailedEvents) {
                statusEnum = IntegrationStatusEnum.Failed;
            } else if (this.showSuccessfulResubmissions) {
                statusEnum = IntegrationStatusEnum.Success;
            }

            criteria = {
                integration_TId: this.model.id,
                integrationStatusEnum: statusEnum,
                integrationSetting_SId: this.showSuccessfulResubmissions ? this.settingId : null,
                isRetryOnly: null
            };

            this.busyService.start();
            this.dataService.getListPaged(`${this.appSettings.API_ENDPOINTS.integration}/ErrorLog`, {
                criteria,
                itemsPerPage: 100000
            })
                .then((data: Array<IIntegrationErrorHeader>) => {
                    if ((this.showFailedEvents && this.showSuccessfulResubmissions) || (!this.showFailedEvents && !this.showSuccessfulResubmissions)) {
                        //data = data.filter(item => item.queueStatus === IntegrationStatusEnum.Failed || item.queueStatus === IntegrationStatusEnum.Success);
                        data = data.filter(item => item.queueStatus === IntegrationStatusEnum.Failed || item.queueStatus === IntegrationStatusEnum.Success || item.queueStatus === IntegrationStatusEnum.Skip);
                    }

                    data.forEach((logItem: IIntegrationErrorHeader) => {
                        logItem.dateCreated = moment(logItem.dateCreated).format("ddd, MMM D, YYYY h:mm:ss A");
                        logItem.dateUpdated = moment(logItem.dateUpdated).fromNow();
                    });

                    this.logList = data;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Toggle successful resubmissions
         * */
        public toggleSuccessful(): void {
            this.settingId = null;
            this.filterLog();
        }

        /**
         * Get item status color
         * */
        public getItemStatusColor(itemStatus: IntegrationStatusEnum): string {
            return itemStatus === IntegrationStatusEnum.Failed ? '#cf2a27' : itemStatus === IntegrationStatusEnum.Success ? '#47e800' : '#ffd966';
        }

        /**
         * Resubmit all errors
         * */
        public resubmit(): void {
            this.modalService.confirm(`Do you want to resubmit all failed attempts for ${this.model.displayName}?`)
                .then(() => {
                    this.dataService.patch(this.appSettings.API_ENDPOINTS.integration, null, new Guid(this.model.id))
                        .then(() => this.filterLog());
                });
        }

        /**
         * Expand error log item details
         * @param {IIntegrationErrorHeader} logItem
         * */
        public expand(logItem: IIntegrationErrorHeader): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/integrations/expandedDetails/expandedDetails.modal.html',
                controller: 'meevo.plugins.integrations.ExpandedDetailModalController',
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: true,
                locals: {
                    logItem
                }
            };

            this.modalService.showCustom(options)
                .then(() => this.filterLog());
        }
    }

}